import { render, staticRenderFns } from "./TopCards.vue?vue&type=template&id=f4e895c4&scoped=true"
import script from "./TopCards.vue?vue&type=script&lang=js"
export * from "./TopCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e895c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e895c4')) {
      api.createRecord('f4e895c4', component.options)
    } else {
      api.reload('f4e895c4', component.options)
    }
    module.hot.accept("./TopCards.vue?vue&type=template&id=f4e895c4&scoped=true", function () {
      api.rerender('f4e895c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/TopCards.vue"
export default component.exports